import { useCallback, useEffect, useMemo, useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useSelector } from "react-redux";

import { swSettings } from "app/common/services/swSettings";
import { EPageIdOption, SegmentsUpsaleBanner } from "app/pages/segments/upsale-banner/SegmentsUpsaleBanner";
import { PopularPagesContainer } from "app/pages/website-analysis/pages/styledComponents";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { EMPTY_CUSTOM_SEGMENTS } from "app/services/segments/segmentsApiService";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";

import { PagesTable } from "./PagesTable";

export const WebAnalysisPagesContainer = () => {
    const params = proNavigator.getApiParams();
    const { customSegmentsMeta } = useSelector((state) => {
        const {
            segmentsModule: { customSegmentsMeta = EMPTY_CUSTOM_SEGMENTS },
        } = state;
        return { customSegmentsMeta };
    });
    const doSegmentsExist = useMemo(
        () => SegmentsUtils.doSegmentsExistInAccount(customSegmentsMeta) || SegmentsUtils.doSegmentsExistInUserData(),
        [customSegmentsMeta],
    );
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;
    const [displaySegmentsUpsaleBanner, setDisplaySegmentsUpsaleBanner] = useState(false);
    const closeSegmentsUpsaleBanner = useCallback(() => setDisplaySegmentsUpsaleBanner(false), []);
    useEffect(() => {
        if (!doSegmentsExist) {
            setDisplaySegmentsUpsaleBanner(true);
        } else {
            setDisplaySegmentsUpsaleBanner(false);
        }
    }, [doSegmentsExist]);

    const isBannerVisible: boolean = proNavigator.current().viewConfig?.hideBanner !== true;

    return (
        <PopularPagesContainer>
            {isBannerVisible ? (
                <SegmentsUpsaleBanner
                    isTopBanner
                    pageId={EPageIdOption.POPULAR_PAGES_ANALYSIS_V2}
                    isVisible={displaySegmentsUpsaleBanner}
                    closeBanner={closeSegmentsUpsaleBanner}
                />
            ) : null}
            <PagesTable
                params={params}
                downloadExcelPermitted={downloadExcelPermitted}
                isDisplayedBanner={displaySegmentsUpsaleBanner}
            />
        </PopularPagesContainer>
    );
};
